import { ERepair } from '../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectRepairFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const RepairContainer: FC = () => {
  const { label, value, options } = useSelector(selectRepairFilter);

  const onChange = useFilterChangeCallback();

  const handleRepairChange = useCallback(
    (newValue: NonEmptyArray<ERepair> | null) => {
      onChange({ action: 'setRepair', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleRepairChange} />
    </AdvancedFilterRow>
  );
};
